import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgIf, NgFor, CommonModule, RouterLink],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  logo_url = "https://www.chemrobotics.com/staging/images/users_profile/"
  profile:any;
  constructor(private datasearch: DatasearchService) { }

  ngOnInit() {
    this.getUserprofiledata();
  }


  getUserprofiledata() {
    const currentUserdata = JSON.parse(localStorage.getItem('currentUser') || '{}');
    // Ensure currentUserdata and email are defined
    if (!currentUserdata || !currentUserdata.email) {
      // console.error('User data is missing or email is not available');
      return;
    }
  
    const email = currentUserdata.email;
  
    const postdata = {
      keyword: email
    };
  
    this.datasearch.getUserprofile(postdata).subscribe(
      (res) => {
        this.profile = res.data;
        // console.log(this.profile);
      },
      (err) => {
        console.error('Error fetching user profile:', err);
      }
    );
  }
  
  

}
